import { useMemo } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';

const DEFAULT_SEGMENT = 'tv';
const WETV_TEXT = {
  iflix: 'iflix',
  tv: 'WeTV',
  tvdtv: 'Tencent Video',
};

const getTvdSegment = (pathname = location.pathname) => {
  const isIflixDomain = document.domain === 'tv.iflix.com' || document.domain === 'test.iflix.com';
  if (isIflixDomain) {
    return 'iflix';
  }
  try {
    const segments = pathname.split('/');
    return segments[1] || DEFAULT_SEGMENT;;
  } catch (error) {
    console.error('Error parsing pathname:', error);
    return DEFAULT_SEGMENT;
  }
};

const WETV_TEXT_CONTENT = WETV_TEXT[getTvdSegment()];

const useCustomTranslation = () => {
  const { t } = useTranslation();
  const { pathname } = location;
  const tvdSegment = useMemo(() => getTvdSegment(pathname), [pathname]);

  const customTranslation = (key, options = {}) => {
    const defaultOptions = {
      WeTV: WETV_TEXT[tvdSegment] || 'WeTV',
      ...options,
    };
    return t(key, defaultOptions);
  };

  return { customTranslation, t: customTranslation };
};

const withCustomTranslation = (WrappedComponent) => {
  const WithCustomTranslation = (props) => {
    const { t } = props;
    const { pathname } = location;
    const tvdSegment = useMemo(() => getTvdSegment(pathname), [pathname]);
    const customTranslation = (key, options = {}) => {
      const defaultOptions = {
        WeTV: WETV_TEXT[tvdSegment] || 'WeTV',
        ...options,
      };
      return t(key, defaultOptions);
    };

    return <WrappedComponent {...props} customTranslation={customTranslation} t={customTranslation} />;
  };

  return withTranslation()(WithCustomTranslation);
};

export { WETV_TEXT_CONTENT, getTvdSegment, useCustomTranslation, withCustomTranslation };
